<template>
  <div class="wt-custom-overlays-stage">
    <area-picker
      v-for="(area, index) in areas"
      :key="area.name"
      :area="area"
      :max-area-z-index="maxAreaZIndex"
      :index="index"
    />
    <point-picker
      v-for="(point, index) in points"
      :key="point.name"
      :point="point"
      :index="index"
    />
  </div>
</template>

<script>
/**
 *  Asset Editor's CustomOverlayssTAGE
 */
import areaPicker from 'AssetEditor/functionality/CustomOverlays/CustomOverlaysAreaPicker.vue';
import pointPicker from 'AssetEditor/functionality/CustomOverlays/CustomOverlaysPointPicker.vue';
import { resolveActive } from 'AssetEditor/functionality/CustomOverlays/objectTrackingApi';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      currentView: 'OverlaysList',
    };
  },

  components: {
    areaPicker,
    pointPicker,
  },

  computed: {
    ...mapGetters('assetEditor', ['currentPage', 'tmpAGD']),

    customFieldsFromAgd() {
      const co = this.tmpAGD.customOverlays;
      const id = this.currentPage && this.currentPage.id;
      const coById = co && co.find((c) => c.id === id);

      if (coById && !_.isEmpty(coById.fields)) {
        return coById.fields;
      } else {
        return null;
      }
    },

    areas() {
      const fields = this.currentPage && _.cloneDeep(this.currentPage.fields);
      const ar = _.filter(fields, { type: 'AREA' });

      if (ar.length) {
        ar.forEach((area, i) => {
          let value;
          const areaFrpmAgd = _.find(this.customFieldsFromAgd || {}, {
            name: area.name,
          });

          if (areaFrpmAgd) {
            value = areaFrpmAgd.value;
          }
          if (area.parentFieldName) {
            const parent = _.find(fields, { name: area.parentFieldName });
            if (parent) {
              area.forceAspect = true;
              area.hasParent = true;
              const parentFromAgd = _.find(this.customFieldsFromAgd, {
                name: parent.name,
              });
              if (parentFromAgd) {
                const o = JSON.parse(parentFromAgd.value);
                area.mediaUrl = o.url;
              }
            }
          }
          if (_.isUndefined(value) || _.isNull(value)) {
            value = area.defaultValue;
          }

          let [offsetX, offsetY, width, height, zIndex] = value.split(' ');
          zIndex = zIndex || i + 1;
          if (
            areaFrpmAgd &&
            !_.isUndefined(areaFrpmAgd.value) &&
            !_.isNull(areaFrpmAgd.value)
          ) {
            Object.assign(area, {
              offsetX,
              offsetY,
              width,
              height,
              zIndex,
              value: areaFrpmAgd.value,
            });
          } else {
            Object.assign(area, { offsetX, offsetY, width, height, zIndex });
          }

          // undefined for fields that have no show/hide toggle - the picker uses
          // that to tell "no active concept" from "hidden"
          const active = resolveActive(area, this.customFieldsFromAgd);
          if (_.isBoolean(active)) {
            area.active = active;
          }
        });
      }

      return ar;
    },

    points() {
      const fields = this.currentPage && _.cloneDeep(this.currentPage.fields);
      const ar = _.filter(fields, { type: 'POINT' });

      if (ar.length) {
        ar.forEach((a, i) => {
          let value;
          const field = _.find(this.customFieldsFromAgd || {}, {
            name: a.name,
          });

          if (field) {
            value = field.value;
          }

          if (_.isUndefined(value) || _.isNull(value)) {
            value = a.defaultValue;
          }

          const [offsetX, offsetY] = value.split(' ');
          if (field && !_.isUndefined(field.value) && !_.isNull(field.value)) {
            Object.assign(a, { offsetX, offsetY, value: field.value });
          } else {
            Object.assign(a, { offsetX, offsetY });
          }
        });
      }

      return ar;
    },

    maxAreaZIndex: function () {
      return _.maxBy(this.areas, 'zIndex').zIndex;
    },
  },

  beforeDestroy() {
    document.body.removeEventListener('click', this.onBodyClickBound);
  },

  mounted() {
    this.onBodyClickBound = this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickBound);
  },

  methods: {
    ...mapMutations('assetEditor', ['setTmpPageState']),

    onBodyClick(e) {
      // closest, not classList: these elements have children (the field's label,
      // its show/hide toggle), and a click on one of those still belongs to the
      // area - matching on the target's own classes would deselect it again
      if (
        e.target.closest &&
        e.target.closest('.shape, .wt-area-picker, .wt-area-picker-stage')
      ) {
        return;
      }

      this.setTmpPageState({ activeOverlay: null });
    },
  },
};
</script>
